<section class="section-wrap">
    <section class="section-banner">
        <div class="container">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 page-404">
                <div class="inner-cls">
                    <h2>404—An error</h2>
                    <h2>occurred...</h2>
                    <a routerLink="/" class="btn btn-default">Back to Home</a>
                </div>
            </div>
        </div>
    </section>
</section>